import VueTypes, { nullable } from 'vue-types';
import { ServiceItem } from '~/themes/novaporta/types/product';

export const layoutsTypes = ['card', 'plank', 'plank-cart', 'plank-showcase'];
export const borderSides = ['right', 'left', 'top', 'bottom'];
export const defaultLayoutType = layoutsTypes[0];

// MODEL: SliderItem
export const SliderItem = VueTypes.shape({
    img: VueTypes.string.isRequired
}).isRequired;

export const createSliderItem = ({ img }) => {
    return {
        img: img
    };
};

// MODEL: BadgeItem
export const BadgeItem = VueTypes.shape({
    name: VueTypes.string.isRequired,
    color: VueTypes.oneOfType([String, null]).def(null),
    backgroundColor: VueTypes.oneOfType([String, null]).def(null)
}).isRequired;

export const createBadgeItem = ({ name, color, backgroundColor }) => {
    return {
        name: name,
        color: color,
        backgroundColor: backgroundColor
    };
};

// MODEL: ParameterItem
export const ParameterItem = VueTypes.shape({
    name: VueTypes.string.isRequired,
    value: VueTypes.string.isRequired
}).isRequired;

export const createParameterItem = ({ name, value }) => {
    return {
        name: name,
        value: value
    };
};

// MODEL: ExtensionProduct
export const ExtensionProduct = VueTypes.shape({
    id: VueTypes.oneOfType([Number, nullable]).def(null),
    extension_id: VueTypes.oneOfType([Number, nullable]).def(null),
    name: VueTypes.string.isRequired,
    product_id: VueTypes.oneOfType([Number, nullable]).def(null),
    price: VueTypes.oneOfType([Number, nullable]).def(null),
    multiplicity: VueTypes.oneOfType([Number, nullable]).def(null),
    keyword: VueTypes.oneOfType([String, nullable]).def(null)
}).isRequired;

export const createExtensionProduct = ({ name, id, extension_id, product_id, price, multiplicity, keyword }) => {
    return {
        id: id,
        name: name,
        extension_id: extension_id,
        product_id: product_id,
        price: price,
        multiplicity: multiplicity,
        keyword: keyword
    };
};

// MODEL: ProductAgent
export const ProductAgent = VueTypes.shape({
    available: VueTypes.bool.isRequired,
    id: VueTypes.number.isRequired,
    name: VueTypes.string.isRequired,
    price: VueTypes.number.isRequired,
    slug: VueTypes.string.isRequired,
    brand: VueTypes.arrayOf(BadgeItem).def([]),
    badges: VueTypes.arrayOf(BadgeItem).def([]),
    slides: VueTypes.arrayOf(SliderItem).def([]),
    parameters: VueTypes.arrayOf(ParameterItem).def([]),
    services: VueTypes.arrayOf(ServiceItem).def([]),
    extensions: VueTypes.arrayOf(ExtensionProduct).def([]),

    isOnSale: VueTypes.bool.def(false),
    img: VueTypes.oneOfType([String, nullable]).def(null),
    oldPrice: VueTypes.oneOfType([Number, nullable]).def(null),
    count: VueTypes.oneOfType([Number, nullable]).def(null),
    quantity: VueTypes.oneOfType([Number, nullable]).def(null)
}).isRequired;

export const createProductAgent = ({
    id,
    name,
    brand,
    price,
    slug,
    stock,
    active,
    available,
    badges = [],
    slides = [],
    parameters = [],
    services = [],
    extensions = [],
    activeExtensions = [],
    multiplicity = 1,
    direction = null,
    count = null,
    quantity = null,
    img = null,
    oldPrice = null,
    isOnSale = false
}) => {
    return {
        active: active,
        available: available,
        id: id,
        name: name,
        brand: brand,
        price: price,
        stock: stock,
        slug: slug,
        img: img,
        oldPrice: oldPrice,
        badges: badges,
        slides: slides,
        parameters: parameters,
        services: services,
        extensions: extensions,
        direction: direction,
        isOnSale: isOnSale,
        count: count,
        quantity: quantity,
        activeExtensions: activeExtensions,
        multiplicity: multiplicity
    };
};

// MOCKS

// ProductAgent
// {
//     id: 1,
//     name: 'Berez Rio-S',
//     price: 43232,
//     slug: 'the-name-of-product',
//     img: null,
//     oldPrice: 132,
//     badges: [
//         createBadgeItem({
//             name: 'The sale thing',
//             color: null,
//             backgroundColor: null,
//         }),
//     ],
//     slides: [
//         createSliderItemProduct({
//             img: 'https://novaporta.md/images/thumbnails/230/230/detailed/11/Rio-s.png.png'
//         }),
//     ],
//     parameters: [
//         createParameterItem({
//             name: 'Dimensiunea',
//             value: '1700 x 600',
//         }),
//     ],
//     isOnSale: true, // if oldPrice is, that means product is on sale
//     count: 1,
// }
